import { render, staticRenderFns } from "./DataTablesComponent.vue?vue&type=template&id=73100cc5&"
import script from "./DataTablesComponent.vue?vue&type=script&lang=js&"
export * from "./DataTablesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/fi-self-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73100cc5')) {
      api.createRecord('73100cc5', component.options)
    } else {
      api.reload('73100cc5', component.options)
    }
    module.hot.accept("./DataTablesComponent.vue?vue&type=template&id=73100cc5&", function () {
      api.rerender('73100cc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue_datatables/DataTablesComponent.vue"
export default component.exports